<div class="flex gap-6">
  <base-form-input
    class="w-1/3"
    label="Préfixe"
    type="select"
    [items]="prefixes"
    [displayProperty]="'displayLabel'"
    controlName="prefix"
  ></base-form-input>

  <div class="w-2/3">
    <base-form-input
      [label]="isOtherPrefix ? 'Numéro (saisie libre)' : 'N° de téléphone'"
      [placeholder]="isOtherPrefix ? 'Ex: 0800123456, 3615, 15...' : ''"
      controlName="phoneNumber"
    ></base-form-input>

    <mat-error
      *ngIf="form.get('phoneNumber')?.hasError('invalidPhoneNumber') && form.get('phoneNumber')?.touched"
      style="font-size: 75%; margin-top: -20px"
    >
      <span *ngIf="!isOtherPrefix">Le numéro de téléphone est invalide pour ce pays</span>
    </mat-error>
  </div>
</div>
